/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect } from "react";
import { useQuery, useClient, useMutation } from "jsonapi-react";
import _ from "lodash";
import DataTable from "react-data-table-component";
import { AppContext } from "../../context/AppContext";
//import { useBodyClass } from "../../helpers/utils";
import CompanyFormComponent from "../../components/CompanyFormComponent/CompanyFormComponent";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import { useToasts } from "react-toast-notifications";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import ModalRightComponent from "../../components/common/ModalRightComponent/ModalRightComponent";
import SearchBar from "../../components/common/Search/Search";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import {
  getCurrentWindowParams,
  checkModuleAddPermission,
  checkModuleDeletePermission,
  checkModuleEditPermission,
  formatTextWithFallback,
  trimDoubleSpace,
  validatorModule,
  checkModuleGeneralPermission,
} from "../../helpers/helpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { VW_ROUTES, apiRoutes } from "../../constants";
import ContextMenuContentWrapper from "../../components/common/ContextMenuContentWrapper";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { convertToFilterQuery, defaultSelectOption } from "../../helpers/utils";
import axios from "axios";
import PillText from "../../components/PillText/PillText";

const Company = ({ location }) => {
  const history = useHistory();

  const initialState = {
    name: "",
  };

  const validationFormat = [
    {
      field: "name",
      preventCharacters: [","],
      minOneAlphabet: true,
      minLength: 3,
      isRequired: true,
      fieldName: "Company Name",
    },
  ];
  const initialErrorState = {
    name: "",
  };
  const { addToast } = useToasts();

  const {
    showRightModal,
    manageRightModal,
    showModal,
    manageModal,
    pagePermissions,
    initialPageParams,
    updateInitialPageParams,
    setPageUrlParams,
    isArchive,
    manageLoader,
    setProfilePageUrlParams,
    userRoleDetails,
  } = React.useContext(AppContext);
  //useBodyClass('modal-open');
  const [mode, setMode] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  const [currentCompanyId, setCurrentCompanyId] = React.useState(0);
  const [currentCompanyAddedProfiles, setCurrentCompanyAddedProfiles] =
    React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [searchQueryString, setSearchQueryString] = React.useState("");
  const [formState, updateFormState] = React.useState(initialState);
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);

  const [intialDataLoaded, setInitialDataLoaded] = React.useState(false);

  const windowParams = getCurrentWindowParams();
  const pageNumber = windowParams.get("page");
  const [currentPageNumber, setCurrentPageNumber] = React.useState(
    Number(pageNumber) || 1
  );

  const [resetPaginationDataTable, setResetPaginationDataTable] =
    React.useState(false);

  const [testData, setTestData] = React.useState();

  const [searchGoingOn, setSearchGoingOn] = React.useState(false);
  const [activePage, setactivePage] = React.useState(null);
  const [errorState, setErrorState] = React.useState(initialErrorState);
  const [createCompany] = useMutation(apiRoutes.company);
  const [filterApplied, setFilterApplied] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");
  const [disableExport, setdisableExport] = React.useState(true);
  const [deleteLoader, setDeleteLoader] = React.useState(false);

  const token = localStorage.getItem("access_token");

  const client = useClient();
  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  let paginationSettings;
  if (searchGoingOn) {
    paginationSettings = {
      number: 1,
      size: rowsPerPage,
    };
  } else {
    paginationSettings = {
      number: currentPageNumber,
      size: rowsPerPage,
    };
  }

  let initialSearchKey;
  const searchWord = window.location.hash.split("search=")[1];
  if (searchWord) {
    initialSearchKey = decodeURI(searchWord);
  } else {
    initialSearchKey = "";
  }

  const [filter, setFilter] = React.useState({
    search: initialSearchKey,
  });

  const [profilesAdded, setProfilesAdded] = React.useState();

  const selectProfileLinked = (e) => {
    setProfilesAdded(e);
  };

  const companies = useQuery(
    activePage && [
      apiRoutes.company,
      {
        filter: filter,
        page: paginationSettings,
      },
    ],
    { client }
  );

  React.useEffect(() => {
    if (!companies.isFetching && !companies.isLoading) {
      if (companies?.data?.length === 0) {
        setdisableExport(true);
      } else {
        setdisableExport(false);
      }
      setInitialDataLoaded(true);
    } else {
      setInitialDataLoaded(false);
    }
  }, [companies]);

  React.useEffect(() => {
    if (location) {
      updateInitialPageParams(location);
    }
  }, []);

  const toggleResetPagination = () => {
    setResetPaginationDataTable((prevToggle) => !prevToggle);
  };

  const url = useLocation();

  const setSearchQueryFromURL = () => {
    const searchWord = windowParams.get("search");
    if (String(searchWord ?? "").length > 0)
      setSearchQueryString(decodeURI(searchWord));
    else setSearchQueryString("");
  };

  const setCurrentPageFromURL = () => {
    const pageNumber = windowParams.get("page");
    if (pageNumber && pageNumber > 0) {
      setCurrentPageNumber(Number(pageNumber));
      setactivePage(Number(pageNumber));
      toggleResetPagination();
    } else {
      setCurrentPageNumber(1);
      setactivePage(1);
      toggleResetPagination();
    }
  };

  useEffect(() => {
    setCurrentPageFromURL();
    setSearchQueryFromURL();
  }, [url]);

  // React.useEffect(() => {
  //   if (initialPageParams) {
  //     setCurrentPageNumber(Number(pageNumber));
  //     // setactivePage(initialPageParams.initialPageNumber);
  //     setactivePage(Number(pageNumber));
  //     setSearchQueryString(initialPageParams.initialSearchKey);
  //   }
  // }, [initialPageParams, pageNumber]);

  const getTestDataOptions = () => [
    defaultSelectOption(),
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const FilterSection = () => {
    return (
      <div className="advance-filter">
        <div className="mb-2">
          <span>Companies</span>
          <div>
            <Select
              placeholder="Select"
              className="cutomSelect"
              classNamePrefix="react-select"
              value={profilesAdded}
              onChange={(e) => selectProfileLinked(e)}
              options={[
                { label: "Select", value: null },
                { label: "No profiles added", value: 0 },
                { label: "Profiles added", value: 1 },
              ]}
              defaultValue={defaultSelectOption()}
            />
          </div>
        </div>
        {checkModuleGeneralPermission(
          userRoleDetails,
          "organisation",
          "view_test_data",
          {},
          true
        ) && (
          <div>
            <span>Test Data</span>
            <Select
              placeholder="Select"
              className="cutomSelect"
              classNamePrefix="react-select"
              options={getTestDataOptions()}
              isMulti={false}
              value={testData}
              defaultValue={defaultSelectOption()}
              onChange={(selectedOptions) => setTestData(selectedOptions)}
            />
          </div>
        )}
      </div>
    );
  };

  const [updateCompany] = useMutation(
    apiRoutes.companyUpdate.replace("{companyId}", currentCompanyId),
    { method: "PUT", client }
  );
  const onInputChange = (e) => {
    if (e.target.name === "name") {
      setCompanyName(trimDoubleSpace(e.target.value?.toUpperCase()));
    }
    updateFormState({
      ...formState,
      [e.target.name]: trimDoubleSpace(e.target.value?.toUpperCase()),
    });
  };
  const manageModalSettings = (status) => {
    manageRightModal(status);
  };

  const deleteCompanyDetails = async () => {
    setDeleteLoader(true);
    const { error } = await client.delete(
      apiRoutes.companyUpdate.replace("{companyId}", currentCompanyId)
    );
    if (error === undefined) {
      setDeleteLoader(false);
      if (companies?.data?.length === 1 && currentPageNumber > 1) {
        paginationSettings = {
          number: currentPageNumber - 1,
          size: rowsPerPage,
        };
        setCurrentPageNumber(currentPageNumber - 1);
      } else {
        companies.refetch();
      }
      addToast(DISPLAY_TEXTS.COMPANY_DELETED, { appearance: "success" });
    } else {
      addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
    }
    setCurrentCompanyId(0);
    manageModal(false);
    setDeleteLoader(false);
  };

  const submitNewCompany = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      if (formState.name !== "") {
        const { data, error } = await createCompany(formState);
        if (data && error === undefined) {
          companies.refetch();
          addToast(DISPLAY_TEXTS.COMPANY_ADDED, { appearance: "success" });
        } else if (error !== undefined && error.detail) {
          addToast(error.detail, { appearance: "error" });
        } else {
          addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
        }
        manageModalSettings(false);
        setCompanyName("");
      }
    }
  };

  const updateCompanyData = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      const { data, error } = await updateCompany({
        ...formState,
        id: currentCompanyId,
      });
      if (data && error === undefined) {
        companies.refetch();
        addToast(DISPLAY_TEXTS.COMPANY_UPDATED, { appearance: "success" });
      } else if (error !== undefined && error.detail) {
        addToast(error.detail, { appearance: "error" });
      } else {
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
      }
      setMode("");
      manageModalSettings(false);
      setCompanyName("");
    }
  };

  const addNewCompany = () => {
    setMode("add");
    setCompanyName("");
    updateFormState({
      name: "",
    });
    setErrorState({
      name: "",
    });
    manageRightModal(true);
  };

  const getCompanyParam = (name) => {
    if (String(name ?? "").length) {
      const param = new URLSearchParams();
      param.append("company_name", name ?? "");
      return param.toString();
    }
    return "";
  };

  const updateCompanyDetails = (id) => {
    setMode("edit");
    setCurrentCompanyId(id);
    const exisitingData = _.keyBy(companies.data, "id")[id];
    setCompanyName(exisitingData.name);
    updateFormState({
      name: exisitingData.name,
    });
    setErrorState({
      name: "",
    });
    manageModalSettings(true);
  };

  const manageDeletedOption = (id, company) => {
    setCurrentCompanyId(id);
    setCurrentCompanyAddedProfiles(company.profilesAdded);
    manageModal(true);
  };

  const doCloseModal = () => {
    setCurrentCompanyId(0);
    manageModal(false);
  };
  const errorValidate = () => {
    let errors = validatorModule(formState, validationFormat);

    return errors;
  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };
  const getEvent = (mode) => {
    if (mode.mode === "edit") {
      updateCompanyDetails(mode.companies.id);
    }

    if (mode.mode === "delete") {
      manageDeletedOption(mode.companies.id, mode.companies);
    }

    if (mode.mode === "profileLink") {
      history.push(
        `${VW_ROUTES.ALL_PROFILES}?${getCompanyParam(mode.companies?.name)}`
      );
    }
  };

  let menuRef = React.useRef();
  React.useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      if (
        event.target.className !== "user-role-action-icons" &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setTableUserId("");
      }
    });
  });
  const [tableUserId, setTableUserId] = React.useState("");
  const showHideContextMenu = (userid) => {
    setTableUserId(userid);
  };
  const renderProfileCard = (companies) => (
    <ProfileCard
      data={companies}
      mode="company"
      actions={userRoleDetails}
      actionsToParent={(mode) => getEvent({ mode, companies })}
      showTestData={checkModuleGeneralPermission(
        userRoleDetails,
        "organisation",
        "view_test_data",
        {},
        true
      )}
    />
  );
  const showContextActionMenu = (company) => {
    const hasCompanyEditPermission = checkModuleEditPermission(
      userRoleDetails,
      "company",
      "company",
      company
    );

    const hasCompanyDeletePermission = checkModuleDeletePermission(
      userRoleDetails,
      "company",
      "company",
      company
    );
    return (
      (hasCompanyEditPermission || hasCompanyDeletePermission) && (
        <div className="contextMenu">
          {tableUserId === company.id && (
            <ContextMenuContentWrapper
              showContextMenu={tableUserId === company.id}
              handleContextMenuClose={() => setTableUserId("")}
            >
              <ul ref={menuRef}>
                {hasCompanyEditPermission && (
                  <>
                    <li onClick={() => updateCompanyDetails(company.id)}>
                      <button>
                        <i className="iconsminds-pen user-role-action-icons"></i>
                        Edit
                      </button>
                    </li>
                  </>
                )}
                {hasCompanyDeletePermission && (
                  <li onClick={() => manageDeletedOption(company.id, company)}>
                    <button>
                      <i className="simple-icon-trash user-role-action-icons delete"></i>
                      Delete
                    </button>
                  </li>
                )}
              </ul>
            </ContextMenuContentWrapper>
          )}
          <span
            className="user-role-action-icons"
            onClick={() => showHideContextMenu(company.id)}
          >
            <i></i>
          </span>
        </div>
      )
    );
  };

  const columns = [
    {
      name: "Company Name",
      selector: (row) => row["name"],
      sortable: true,
      cell:
        Object.keys(userRoleDetails?.modulePermissions["company"] ?? {})
          ?.length > 0
          ? renderProfileCard
          : "",
    },
    {
      name: "Added profiles",
      maxWidth: 200,
      selector: (row) => row["profilesAdded"],
      sortable: true,
      center: true,
      cell: (companies) => (
        <>{formatTextWithFallback(companies.profilesAdded)}</>
      ),
      hide: "md",
    },

    {
      name: "Test Data",
      sortable: false,
      maxWidth: "300px",
      hide: "md",
      omit: !checkModuleGeneralPermission(
        userRoleDetails,
        "organisation",
        "view_test_data",
        {},
        true
      ),
      cell: (company) => (
        <PillText
          label={company?.isTestCompany ? "Yes" : "No"}
          type={company?.isTestCompany ? "active" : "inactive"}
          mapper={{ active: "Yes", inactive: "No" }}
        />
      ),
    },

    {
      name: "Actions",
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      center: true,
      cell: (company) => (
        <div className="actionColumn j-flx-end">
          {company.profilesAdded > 0 && (
            <Link
              to={`${VW_ROUTES.ALL_PROFILES}?${getCompanyParam(company?.name)}`}
              title="View linked profiles"
            >
              <span className="iconsminds-link user-role-action-icons edit"></span>
            </Link>
          )}
          {showContextActionMenu(company)}
        </div>
      ),
      hide: "md",
      right: true,
    },
  ];

  let paginationGoing = false;
  const onChangePage = (page) => {
    setSearchGoingOn(false);
    paginationGoing = true;
    setCurrentPageNumber(page);
    const setParams = {
      page: page,
      searchQueryString: searchQueryString,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  const onChangeRowsPerPage = (rows) => {
    setRowsPerPage(rows);
  };

  let searchGoing = false;
  const onSearchInputChange = (searchQuery) => {
    searchGoing = true;
    setSearchGoingOn(true);
    setSearchQueryString(searchQuery);
    setFilter({ ...filter, search: searchQuery });
    setactivePage(1);
    const setParams = {
      page: 1,
      searchQueryString: searchQuery,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  window.onpopstate = (e) => {
    if (!searchGoing && !paginationGoing) {
      const searchWord = window.location.hash.split("search=")[1];
      const wordString = decodeURI(searchWord);
      if (searchWord) {
        setSearchQueryString(wordString);
        setFilter({ ...filter, search: wordString });
      } else {
        setSearchQueryString("");
        setFilter({ ...filter, search: "" });
      }

      const pageNumber = window.location.hash.split("page=")[1];
      if (pageNumber) {
        const pageFromUrl = pageNumber.split("&")[0];
        setCurrentPageNumber(Number(pageFromUrl));
      } else {
        setCurrentPageNumber(1);
      }
    } else {
      searchGoing = false;
      paginationGoing = false;
    }
  };
  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };

  const handleResetFilter = () => {
    for (let key of ["profiles_added", "profiles_added_gt", "test_data"]) {
      delete filter[key];
    }
    setTestData();
    setFilter({ ...filter });
    setProfilesAdded();
  };

  React.useEffect(() => {
    if (
      _.hasIn(filter, "profiles_added") ||
      _.hasIn(filter, "profiles_added_gt") ||
      _.hasIn(filter, "test_data")
    ) {
      setFilterApplied(true);
      return;
    }
    setFilterApplied(false);
  }, [filter]);

  const handleApplyFilter = () => {
    setCurrentPageNumber(1);
    showFilter(false);

    let updatedFilter = { ...filter };

    if (profilesAdded?.value == 0) {
      delete updatedFilter.profiles_added_gt;
      updatedFilter.profiles_added = 0;
    } else if (profilesAdded?.value == 1) {
      delete updatedFilter.profiles_added;
      updatedFilter.profiles_added_gt = 0;
    } else {
      delete updatedFilter.profiles_added;
      delete updatedFilter.profiles_added_gt;
    }
    const selectedTestData =
      testData?.value !== undefined && testData?.value !== ""
        ? testData?.value
        : null;

    if (selectedTestData !== null) {
      updatedFilter.test_data = selectedTestData;
    } else {
      delete updatedFilter.test_data;
    }
    setFilter(updatedFilter);
  };

  const closeReportSuccessPopup = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };

  const onExport = () => {
    manageLoader(true);
    let filterQuery = convertToFilterQuery(filter);

    const options = {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `JWT ${token}`,
      },
      url: `${apiRoutes.companyListExport}?${filterQuery}`,
    };
    axios(options)
      .then((response) => {
        manageLoader(false);
        setShowSuccessModal(true);
        setShowSuccessMessage(response.data.data.message);
      })
      .catch((error) => {
        manageLoader(false);
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, {
          appearance: "error",
        });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-header">
            <h1>Companies</h1>
            <div className="applicantFilter">
              <div className="desktopSearch">
                <SearchBar
                  onSearchInputChange={onSearchInputChange}
                  popstateText={searchQueryString}
                />
              </div>
              <div
                className={
                  showMobileDataFilter ? "table-filter active" : "table-filter"
                }
              >
                <div
                  className="filter-hide"
                  onClick={() => showFilter(false)}
                ></div>
                <div className="filter-form">
                  <div className="mobile-search">
                    <SearchBar
                      onSearchInputChange={onSearchInputChange}
                      popstateText={searchQueryString}
                    />
                  </div>
                  <h4 className="advanced-filter-heading">Advanced Search</h4>
                  <FilterSection />
                  <div className="d-flex w-100 align-items-center justify-content-end mt-3">
                    <button
                      className="btn btn-primary mr-2"
                      onClick={(e) => {
                        handleResetFilter(e);
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary m-0"
                      onClick={(e) => {
                        handleApplyFilter(e);
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
              <div
                className={`tableFilterButton rightAlign  ${
                  filterApplied ? "btn-secondary" : ""
                }`}
                title="Advanced Search"
                onClick={() => showFilter(true)}
              >
                <i className="iconsminds-filter-2"></i>
              </div>
              {checkModuleAddPermission(
                userRoleDetails,
                "company",
                "company"
              ) && (
                <button
                  type="button"
                  title="Add Company"
                  className="tableFilterButton ml-2 rightAlign btn-secondary"
                  onClick={() => addNewCompany()}
                >
                  <>+</>
                </button>
              )}
              {checkModuleGeneralPermission(
                userRoleDetails,
                "company",
                "export_company_list"
              ) && (
                <button
                  onClick={onExport}
                  className="btn btn-secondary rounded-0 ml-2"
                  disabled={disableExport}
                >
                  Export
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            <div
              className={
                companies.isLoading || companies.isFetching || !intialDataLoaded
                  ? "card-body dataTableOuter table-loader"
                  : "card-body dataTableOuter"
              }
            >
              <DataTable
                subHeader={true}
                progressPending={
                  companies.isLoading ||
                  companies.isFetching ||
                  !intialDataLoaded
                }
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={companies.data}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={
                  companies.meta && companies.meta.pagination.count
                }
                paginationDefaultPage={activePage}
                paginationResetDefaultPage={resetPaginationDataTable}
              />
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        show={showModal}
        header={<b>Confirm Delete</b>}
        content={
          <>
            <p>
              Are you sure you want to delete the selected Company details ?
            </p>
            {currentCompanyAddedProfiles > 0 && (
              <p>
                Please note: {currentCompanyAddedProfiles} profiles are linked
                to this company{" "}
              </p>
            )}
          </>
        }
        onSubmitCallback={deleteCompanyDetails}
        onCloseCallback={doCloseModal}
        submitButtonText="Delete"
        isLoaderActive={deleteLoader}
        customClass="delete"
      />

      <ModalRightComponent
        show={showRightModal}
        header={mode === "add" ? "Add Company" : "Update Company"}
        submitButtonText={mode === "add" ? "Submit" : "Update"}
        classes="normal-right-modal"
        content={
          <CompanyFormComponent
            title={
              mode === "add"
                ? 'Submitting below form will add "a new company".'
                : 'Submitting below form will update "the company".'
            }
            companyName={companyName}
            errorState={errorState}
            updateInputChange={onInputChange}
          />
        }
        onSubmitCallback={() =>
          mode === "add" ? submitNewCompany() : updateCompanyData()
        }
        onCloseCallback={() => manageModalSettings(false)}
      />
      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeReportSuccessPopup}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Company;
